import { configPrepare } from "@/helpers/vue-good-table"
import { map } from "lodash-es"

const defaultTableProperties = {
  tdClass: "accounts-table-td",
  thClass: "accounts-table-th",
  sortable: true
}

const i18nPrefix = "accounts.table.columns"

const fields = [
  {
    field: "account_id",
    thClass: "accounts-table-th account-id-field",
    tdClass: "accounts-table-td account-id-field"
  },
  {
    label: `${i18nPrefix}.shop`,
    field: "shops",
    formatFn: shops => map(shops, "name").join(", ") || "—",
    thClass: "accounts-table-th expandable-field",
    tdClass: "accounts-table-td expandable-field"
  },
  {
    label: `${i18nPrefix}.role`,
    field: "role"
  },
  {
    field: "full_name",
    thClass: "accounts-table-th expandable-field",
    tdClass: "accounts-table-td expandable-field"
  },
  {
    label: `${i18nPrefix}.email`,
    field: "email",
    formatFn: email => email || "—",
    thClass: "accounts-table-th expandable-field",
    tdClass: "accounts-table-td expandable-field"
  },
  {
    label: `${i18nPrefix}.phone_number`,
    field: "phone_number",
    formatFn: phone_number => phone_number || "—",
    thClass: "accounts-table-th expandable-field",
    tdClass: "accounts-table-td expandable-field"
  },
  {
    field: "current_sign_in_at",
    formatFn: current_sign_in_at => current_sign_in_at || "—",
    thClass: "accounts-table-th last-login-at-field",
    tdClass: "accounts-table-td last-login-at-field"
  },
  {
    label: "",
    field: "actions",
    tdClass: "accounts-table-td text-right actions-field",
    sortable: false
  }
]

export const columns = () => configPrepare(fields, { i18nPrefix, defaults: defaultTableProperties })
